import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import Headphone from "../../assets/icons/Headphone";

export default function HeaderTop({ headerApps = [] }) {
  const { push } = useHistory();
  const [isShow, setIsShow] = useState(false);
  const [isShowDownload, setIsShowDownload] = useState(false);
  const bantuanRef = useRef(null);
  const dropdownMenuRef = useRef(null);
  const downloadRef = useRef(null);

  const rightmenu = [
    { title: "Hubungi Kami", path: "/hubungi-kami" },
    { title: "Prosedur", path: "/prosedur" },
    { title: "Tentang Kami", path: "/tentang-kami" },
  ];

  const clickPath = (path) => {
    push(path);
  };

  useEffect(() => {
    function handleClickOutside(e) {
      if (
        bantuanRef.current &&
        !bantuanRef.current.contains(e.target) &&
        (!dropdownMenuRef.current || !dropdownMenuRef.current.contains(e.target))
      ) {
        setIsShow(false);
      }
      if (downloadRef.current && !downloadRef.current.contains(e.target)) {
        setIsShowDownload(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <nav className="text-primary" style={{ backgroundColor: "#F0F2F5" }}>
      <div className="container py-2 font-xs fw-semibold">
        <div className="d-flex fw-bold justify-content-between align-items-center">
          <div
            ref={bantuanRef}
            className="d-flex justify-content-between align-items-center cursor-pointer"
            onClick={() => setIsShow(!isShow)}
          >
            <Headphone />
            <p className="mb-0 ms-2">Bantuan</p>
          </div>
          {isShow ? (
            <div
              ref={dropdownMenuRef}
              className="position-absolute"
              style={{
                backgroundColor: "#FFFFFF",
                marginTop: "120px",
                padding: "10px",
                borderRadius: "8px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              <div className="menu-dropdown" onClick={() => clickPath("/faq")}>
                FAQ
              </div>
              <div className="menu-dropdown" onClick={() => clickPath("/lokasi-kami")}>
                Lokasi Cabang
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="d-flex items-align-center">
            {rightmenu.map((el, idx) => (
              <div className="cursor-pointer mx-2" key={`right-menu-${idx + 1}`} onClick={() => clickPath(el.path)}>
                <p className="mb-0">{el.title}</p>
              </div>
            ))}
            <div
              ref={downloadRef}
              className="cursor-pointer mx-2 d-none d-lg-block d-xl-block"
              key={`right-menu-4`}
              onClick={() => setIsShowDownload(!isShowDownload)}
            >
              <p className="mb-0">Download Aplikasi</p>
              {isShowDownload ? (
                <div
                  className="position-absolute"
                  style={{
                    backgroundColor: "#FFFFFF",
                    marginTop: "3px",
                    padding: "10px",
                    borderRadius: "8px",
                    right: "50px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                    zIndex: 50,
                  }}
                >
                  {/* <div className="menu-dropdown" onClick={() => clickPath("/faq")}>
                    Play Store
                  </div>
                  <div className="menu-dropdown" onClick={() => clickPath("/lokasi-kami")}>
                    App Store
                  </div> */}
                  {headerApps.map((el, idx) => (
                    <a href={el.path} target="_blank" className="w-100" key={idx} rel="noreferrer">
                      <img src={el.image} alt={el.name} />
                    </a>
                  ))}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
